import React from 'react';
import { Formik } from 'formik';
import { Form, Field } from 'library/forms';
import { SubmitButton } from 'library/buttons';

const ResetPasswordFormRender = ({ errors, touched, isSubmitting, onResetHook, resetForm }) => {
  onResetHook(resetForm);
  return (
    <Form errors={errors} touched={touched} style={{ display: 'flex', flexDirection: 'column' }}>
      <Field type="password" name="password" label="CURRENT_PASSWORD" />
      <Field type="password" name="new_password" label="NEW_PASSWORD" />
      <Field type="password" name="confirm" label="CONFIRM_PASSWORD" />
      <SubmitButton disabled={isSubmitting}>Submit</SubmitButton>
    </Form>
  );
};

const validate = ({ password, new_password, confirm }) => {
  const errors = {};
  if (!password || password.length < 6) {
    errors.password = 'INVALID_PASSWORD';
  }
  if (!new_password || new_password.length < 6) {
    errors.new_password = 'INVALID_PASSWORD';
  }
  if (new_password !== confirm) {
    errors.confirm = 'INVALID_PASSWORD_CONFIRM';
  }
  return errors;
};

const ResetPasswordForm = ({ onSubmit, onResetHook }) => {
  return (
    <Formik
      initialValues={{ new_password: '', password: '', confirm: '' }}
      onSubmit={async (values, actions) => {
        await onSubmit(values);
        actions.setSubmitting(false);
      }}
      validate={values => validate(values)}
      render={p => <ResetPasswordFormRender {...p} onResetHook={onResetHook} />}
    />
  );
};

export default ResetPasswordForm;
